import { render, staticRenderFns } from "./ImageForm.vue?vue&type=template&id=4130fa7d&scoped=true"
import script from "./ImageForm.vue?vue&type=script&lang=js"
export * from "./ImageForm.vue?vue&type=script&lang=js"
import style0 from "./ImageForm.vue?vue&type=style&index=0&id=4130fa7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4130fa7d",
  null
  
)

export default component.exports